// Thin wrapper over Plausible. `track(event, props?)` is a no-op if the
// analytics script has been blocked (privacy extensions, offline, etc.).
export function track(event, props) {
  if (typeof window === 'undefined') return;
  try {
    if (typeof window.plausible === 'function') {
      window.plausible(event, props ? { props } : undefined);
    }
  } catch {
    /* analytics never throws */
  }
}
